import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectiveRangeComponent } from './effective-range.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExpiresAtModule } from './expires-at/expires-at.module';
import { StartsAtModule } from './starts-at/starts-at.module';

@NgModule({
  declarations: [EffectiveRangeComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    ExpiresAtModule,StartsAtModule,
  ],
  exports: [EffectiveRangeComponent],
  entryComponents: [EffectiveRangeComponent],
})
export class EffectiveRangeModule { }
